import script from "./InvestimentoAtivoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestimentoAtivoFormView.vue?vue&type=script&setup=true&lang=js"

import "./InvestimentoAtivoFormView.vue?vue&type=style&index=0&id=11eed398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11eed398"]])

export default __exports__